module.exports = __webpack_public_path__ + "static/img/about_financing_01_zh.ebf3d64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_financing_01_zh.png
// module id = ES8+
// module chunks = 34